/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-01-25 16:42:54
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-18 23:01:34
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Menu/Menu.tsx
 */
import { Menu } from 'antd';
//import css from './SalesChannelEditorPromotion.less';

import React from 'react';
const CustomMenu = (props) => {
  const { children, ...rest } = props;
  return <Menu {...rest}>{children}</Menu>;
};
export default CustomMenu;
